import { AppDataDriver } from '@mobilesaude/frontend_libs'
import store from '@/Store'
import {
  findContractByID,
  findDadosBeneficiario
} from '@mobilesaude/frontend_libs/helpers/usuario'
import { EnumPerfilUsuario } from '@mobilesaude/frontend_libs/enums/EnumsBeneficiario'

const useAppDataDriver = () => {
  const beneficiariosFromLogin = store.getters['Login/beneficiarios']
  const contratosFromLogin = store.getters['Login/contratos']
  const hasMultPerfil = store.getters['Login/hasMultPerfil']
  const usuarioLogado = store.getters['Login/dadosUsuarioLogado']
  const prestador = store.getters['RedeCredenciada/prestador']

  const formatJSON = ({
    idFuncionalidade,
    camposFormbuiler,
    beneficiarioSelecionado = null,
    integracao = null,
    ocorrencia = null,
    formulario = null
  }) => {
    let dataDriver = {}
    if (beneficiarioSelecionado) {
      dataDriver.beneficiario = {
        beneficiario: null,
        contrato: null
      }
      if (beneficiarioSelecionado.beneficiarioDados) {
        dataDriver.beneficiario.beneficiario = findDadosBeneficiario(
          beneficiarioSelecionado.chaveUnica,
          beneficiariosFromLogin,
          beneficiarioSelecionado.numeroContrato
        )
      }

      dataDriver.beneficiario.contrato = findContractByID(
        contratosFromLogin,
        beneficiarioSelecionado.numeroContrato
      )
    }

    if (hasMultPerfil) {
      dataDriver.usuario = {
        perfil: {},
        contrato: {}
      }

      if (beneficiarioSelecionado) {
        dataDriver.usuario.contrato = dataDriver.beneficiario.contrato
      }

      usuarioLogado.perfis.forEach(perfil => {
        if (perfil.chavePerfil === EnumPerfilUsuario.beneficiario) {
          if (dataDriver.beneficiario.beneficiario) {
            dataDriver.usuario.perfil.beneficiario = dataDriver.beneficiario.beneficiario
          }
          return
        }
        dataDriver.usuario.perfil[perfil.chavePerfil] = perfil.dadosPerfil
      })
    }

    if (ocorrencia) {
      dataDriver.ocorrencia = ocorrencia
    }

    if (integracao) {
      dataDriver.integracao = integracao.data
    }

    if (prestador) {
      dataDriver.prestador = prestador
    }
    if (usuarioLogado) {
      dataDriver.usuarioLogado = usuarioLogado
    }

    if (formulario) {
      dataDriver.formulario = formulario
    }

    const appDataDrive = new AppDataDriver()
    return appDataDrive.mapKeyCustomValues(camposFormbuiler, dataDriver)
  }

  return {
    formatJSON: formatJSON
  }
}

export default useAppDataDriver
